import {Box, Chip, Stack, Typography} from "@mui/material";
import TextWithIcon from "../TextWithIcon";
import {toLocalDate} from "../../utils/formatData";
import {FiCalendar, FiHash, FiFileText} from "react-icons/fi";
import {useTheme} from "@mui/material";

const TenantInfo = ({tenant}) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        borderRadius: theme.palette.card.borderRadius,
        border: `1px solid ${theme.palette.card.border}`,
        padding: 3,
        bgcolor: theme.palette.card.background,
        boxShadow: theme.palette.card.borderShadow
      }}
    >
      {/* Header: Nombre + Status */}
      <Stack direction="row" spacing={2} alignItems="center" mb={2}>
        <Typography variant="h2" fontWeight="bold" color={theme.palette.text.primary}>
          {tenant?.name}
        </Typography>
        <Chip
          label={tenant?.status === "active" ? "Activo" : "Inactivo"}
          color={tenant?.status === "active" ? "success" : "default"}
          size="small"
        />
      </Stack>

      {/* Datos del tenant */}
      <Stack ml={1} spacing={1.5}>
        <TextWithIcon Icon={FiFileText} text={`NIF: ${tenant?.nif || "-"}`} />
        <TextWithIcon Icon={FiHash} text={`ID: ${tenant?.id || "-"}`} />
        <TextWithIcon Icon={FiCalendar} text={toLocalDate(tenant?.created_at)} />
      </Stack>
    </Box>
  );
};

export default TenantInfo;
